import RuleProvider from 'diagram-js/lib/features/rules/RuleProvider';
import inherits from 'inherits';

/**
 * @param {import("diagram-js/lib/core/EventBus").default<null>} eventBus
 * @param {boolean} eventResizingEnabled
 */
export function ResizeEvent(eventBus, eventResizingEnabled) {
    // @ts-expect-error
    RuleProvider.call(this, eventBus);
    this.eventResizingEnabled = eventResizingEnabled || false;
}

inherits(ResizeEvent, RuleProvider);

ResizeEvent.$inject = ['eventBus', 'config.eventResizingEnabled'];

ResizeEvent.prototype.init = function () {
    const me = this;

    // @ts-expect-error
    me.addRule('shape.resize', 1500, function (/** @type {{ shape: { businessObject: { $instanceOf: (arg0: string) => any; }; }; newBounds: { width: number; height: number; }; }} */ data) {
        if (me.eventResizingEnabled && data.shape.businessObject &&
            data.shape.businessObject.$instanceOf('bpmn:Event')) {
            if (data.newBounds) {
                data.newBounds.width = Math.max(36, data.newBounds.width);
                data.newBounds.height = Math.max(36, data.newBounds.height);
            } return true;
        }
    });
};